"use client"

import { DefaultImage } from "@/lib/external-components"
import { toImageSrc } from "@/lib/utils"
import { HeroBannerWithBreadcrumbContentProps } from "@/types/types"
import Image from "next/image"
import Link from "next/link"
import { twMerge } from "tailwind-merge"

export const HeroBannerWithBreadcrumbContent = ({
  id,
  breadcrumb,
  image,
  title,
  className,
  isTamdaOne = false,
}: HeroBannerWithBreadcrumbContentProps) => {
  const imageUrl = image ? toImageSrc(image) : ""
  const imageSrc = imageUrl || DefaultImage

  const titleMobileFontSize = isTamdaOne ? "text-[19.2px]" : "text-2xl"
  const categoryMobileFontSize = isTamdaOne ? "text-base" : "text-sm"
  const titleMobileLineHeight = isTamdaOne ? "leading-[23.04px]" : "leading-[2.1rem]"
  // Height cho mobile: 437px cho tamdaone, 362px cho các site khác
  const mobileMaxHeight = isTamdaOne ? "h-[300px] sm:h-[437px]" : ""

  return (
    <div
      id={id}
      className={twMerge(
        `relative w-full h-full ${mobileMaxHeight} lg:max-h-[362px] overflow-hidden pt-10 pb-[3.75rem] lg:pt-[7.4375rem] lg:pb-[9.125rem]`,
        className,
      )}
    >
      <div className="absolute inset-0">
        <Image alt={title || "Banner"} src={imageSrc} fill className="object-cover" sizes="100vw" priority unoptimized={imageSrc.startsWith("http")} />
        <div className="absolute inset-0 bg-black/[0.3] z-0" />
      </div>
      <div className="container relative z-10 ">
        <div className=" lg:px-[5.625rem] flex items-center justify-center lg:justify-start w-full">
          <div className="col-lg-12 col-12">
            <div className={`flex flex-col ${isTamdaOne ? "gap-0 pt-12 px-8 pb-0" : ""} sm:pt-0 sm:px-0 lg:gap-4 `}>
              <div className={`flex flex-row items-center ${isTamdaOne ? "justify-center sm:justify-start" : ""}`}>
                {breadcrumb &&
                  breadcrumb.length > 0 &&
                  breadcrumb.map((item, index) => (
                    <span
                      key={index}
                      className={`text-[#DAD9D8] ${categoryMobileFontSize} lg:text-xl leading-[1.3125rem] lg:!leading-5.5 font-bold uppercase transition-colors duration-300`}
                    >
                      <Link href={item.link || "#"} className="no-underline hover:text-[#157e40]">
                        {item.title}
                      </Link>

                      {index < breadcrumb.length - 1 && <span className="px-2">-</span>}
                    </span>
                  ))}
              </div>
              {title && (
                <h1
                  className={`text-white ${titleMobileFontSize} lg:text-[3.125rem] ${titleMobileLineHeight} lg:leading-[3.875rem] font-black uppercase text-center lg:text-left`}
                >
                  {title}
                </h1>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
